import React, { useEffect } from "react";
import { ReactComponent as CartIcon } from "svgs/fi-rs-shopping-cart.svg";
import { useSettings, useCart } from "hooks/useStore";
import { trackCartIconClick } from "analytics";
import Link from "components/link";
import clsx from "clsx/lite";

const ShoppingCart = ({ redirectToCartPage = false, embedHeader }) => {
	const { totalQuantity, shippingProtection } = useCart(["totalQuantity", "shippingProtection"]);
	const { toggleCart, toggleSearch, toggleMenu, isMenuOpen, isSearchOpen } =
		useSettings(["toggleCart", "toggleSearch", "toggleMenu", "isMenuOpen", "isSearchOpen"]);
	const { selected } = shippingProtection || {};

	const handleClick = () => {
		if (!redirectToCartPage) toggleCart();
		trackCartIconClick();
	};

	//Expose cart quantity to React Native WebView
	useEffect(() => {
		if (typeof window !== "undefined" && window.ReactNativeWebView) {
			window.ReactNativeWebView.postMessage(
				JSON.stringify({ type: "CART_UPDATE", totalQuantity: selected ? totalQuantity - 1 : totalQuantity })
			);
		}
	}, [totalQuantity, selected]);

	const handleCartLinkClick = () => {
		if (isSearchOpen) toggleSearch();
		if (isMenuOpen) toggleMenu();
	};

	const Badge = () => (
		totalQuantity > 0 && (
			<span className="absolute -top-2 -left-2 bg-beige text-white px-1.5 rounded-full text-xs">
				{selected ? totalQuantity - 1 : totalQuantity}
			</span>
		)
	);

	if (redirectToCartPage) {
		return (
			<Link to="/cart" onClick={handleCartLinkClick}
				className="flex relative text-white rounded cursor-pointer" aria-label="shopping cart">
				<CartIcon className={clsx(embedHeader && "invert")} />
				<Badge />
			</Link>
		);
	}

	return (
		<button onClick={handleClick}
			className="flex relative text-white rounded cursor-pointer" aria-label="shopping cart">
			<CartIcon className={clsx(embedHeader && "invert")} />
			<Badge />
		</button>
	);
};

export default ShoppingCart;
